import { AxiosError } from 'axios';
import { TextComponent } from 'baseComponents/TextComponent';
import { ApiError, JWTError } from 'types/utils/api-response';

export const getAuthErrorMessage = (error: AxiosError<ApiError | JWTError>) => {
  const res = error?.response;
  const data = res?.data;

  if (!data) return null;

  if ('message' in data) return data.message;
  if ('msg' in data) return data.msg;
};

export const parseErrorMessage = (message: string) => {
  if (message.includes('<a')) {
    const startIndex = message.indexOf("<a href='") + "<a href='".length;
    const endIndex = message.indexOf("'>here</a>");

    const startMessage = message.substring(0, startIndex - "<a href='".length);
    const link = message.substring(startIndex, endIndex);
    const restMessage = message.substring(endIndex + "'>here</a>".length);
    return (
      <>
        <TextComponent
          type='span'
          size='middle'
          styleType='danger'
          text={startMessage}
        />
        <a href={link} style={{ color: '#ff0000', fontFamily: 'sans-serif' }}>
          here
        </a>
        <TextComponent
          type='span'
          size='middle'
          styleType='danger'
          text={restMessage}
        />
      </>
    );
  }
  return <TextComponent size='middle' styleType='danger' text={message} />;
};

export const parseValidationErrorMessage = (error: any) => {
  const passwordErrors = error?.response?.data?.data?.password;
  return passwordErrors.map((e: string) => {
    switch (e) {
      case 'length':
        return (
          <TextComponent
            key={error}
            styleType='danger'
            text='Password should be at least 12 characters long'
          />
        );
      case 'numbers':
        return (
          <TextComponent
            key={error}
            styleType='danger'
            text='Password should contain at least one number'
          />
        );
      case 'uppercase':
        return (
          <TextComponent
            key={error}
            styleType='danger'
            text='Password should contain at least one uppercase character'
          />
        );
      case 'special':
        return (
          <TextComponent
            key={error}
            styleType='danger'
            text='Password should contain at least one special character'
          />
        );
      default:
        return null; // handle unknown errors if necessary
    }
  });
};
